import { GetFormularyListApiParameter } from "@GeriMed/Services/FormularyListService";
import { FormularyListState } from "@GeriMed/Store/Data/FormularyList/FormularyListState";
import { CustomerDisplayProductCollection } from "@GeriMed/Type/ApiModelsExt";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

const initialState: FormularyListState = {
    isLoading: {},
    byId: {},
    dataViews: {},
    errorStatusCodeById: {},
};

const reducer = {
    "Data/FormularyList/BeginLoadFormularyList": (
        draft: Draft<FormularyListState>,
        action: { parameter: GetFormularyListApiParameter },
    ) => {
        setDataViewLoading(draft, action.parameter);
    },

    "Data/FormularyList/CompleteLoadFormularyList": (
        draft: Draft<FormularyListState>,
        action: { parameter: GetFormularyListApiParameter; collection: CustomerDisplayProductCollection },
    ) => {
        setDataViewLoaded(
            draft,
            action.parameter,
            action.collection,
            collection => action.collection.productList,
        );
    },
    "Data/FormularyList/Reset": () => {
        return initialState;
    },
};

const formularyListreducer = createTypedReducerWithImmer(initialState, reducer);
(reducers as any).dataFormularyList = formularyListreducer;
